// DO NOT EDIT -- generated from fs/services/orgs/auth.proto

import { ApiScope } from './api_scopes.proto';
import { AppearanceMode, EmbedRole, OnboardingCompletion, Org, Person, PersonLevel0, Role } from './model.proto';
import * as auth from '../../auth/sessionpb';
import * as flags from '../../shared/flags';
import * as protobuf from '../../../google/protobuf';

/**
 * Service Auth provides support for authn|z: Person management, SSO (Auth0) management,
 * API key management, and authentication via passwords, tokens, API keys, etc.
 * ////////////////////////
 * Authentication, APIs
 * ////////////////////////
 */
export namespace Auth {

  export const GetApiMetadataEndpoint = "/grpc/orgs.Auth/GetApiMetadata";
  /**
   * GetApiMetadata authenticates an org + API key combination and, if auth
   * is successful, fetches API quota/rate-limiting parameters.
   * NB: a successful call to GetApiMetadata does not equate to successful authn;
   * the caller must check auth_success on the response.
   */
  export function GetApiMetadata(sender: (req: GetApiMetadataRequest, endpoint: string) => Promise<GetApiMetadataResponse>, req: GetApiMetadataRequest): { promise: () => Promise<GetApiMetadataResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetApiMetadataEndpoint),
      endpoint: GetApiMetadataEndpoint
    };
  }

  export const GetApiKeysEndpoint = "/grpc/orgs.Auth/GetApiKeys";
  /** GetApiKeys fetches all the API keys to which a user has access. */
  export function GetApiKeys(sender: (req: GetApiKeysRequest, endpoint: string) => Promise<GetApiKeysResponse>, req: GetApiKeysRequest): { promise: () => Promise<GetApiKeysResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetApiKeysEndpoint),
      endpoint: GetApiKeysEndpoint
    };
  }

  export const DeleteApiKeyEndpoint = "/grpc/orgs.Auth/DeleteApiKey";
  /** DeleteApiKey tombstones and removes a single key. */
  export function DeleteApiKey(sender: (req: DeleteApiKeyRequest, endpoint: string) => Promise<{}>, req: DeleteApiKeyRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteApiKeyEndpoint),
      endpoint: DeleteApiKeyEndpoint
    };
  }

  export const DeleteApiKeysForSeatEndpoint = "/grpc/orgs.Auth/DeleteApiKeysForSeat";
  /** DeleteApiKeysForSeat tombstones and removes all the keys with a given seatId. */
  export function DeleteApiKeysForSeat(sender: (req: DeleteApiKeysForSeatRequest, endpoint: string) => Promise<{}>, req: DeleteApiKeysForSeatRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteApiKeysForSeatEndpoint),
      endpoint: DeleteApiKeysForSeatEndpoint
    };
  }

  export const GenerateUserApiKeyEndpoint = "/grpc/orgs.Auth/GenerateUserApiKey";
  /**
   * GenerateUserApiKey creates and returns a new per-user API key and its identifying suffix.
   * Internal users are not allowed to call this endpoint.
   */
  export function GenerateUserApiKey(sender: (req: GenerateUserApiKeyRequest, endpoint: string) => Promise<GenerateUserApiKeyResponse>, req: GenerateUserApiKeyRequest): { promise: () => Promise<GenerateUserApiKeyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateUserApiKeyEndpoint),
      endpoint: GenerateUserApiKeyEndpoint
    };
  }

  export const UpdateUserApiKeyEndpoint = "/grpc/orgs.Auth/UpdateUserApiKey";
  /**
   * UpdateUserApiKey updates the name and/or the role of of a given user api key. The request must contain either a
   * name update and/or role update, the api key metadata (seatId, suffix), and a valid org id. The new_role field
   * being set to orgs.Role_UNKNOWN and the new_name field being set to an empty string will be interpreted as a
   * no update. On a successful update, an empty protobuf message will be returned.
   * Internal users are not allowed to call this endpoint.
   */
  export function UpdateUserApiKey(sender: (req: UpdateUserApiKeyRequest, endpoint: string) => Promise<{}>, req: UpdateUserApiKeyRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateUserApiKeyEndpoint),
      endpoint: UpdateUserApiKeyEndpoint
    };
  }

  export const GetAvailableApiScopesEndpoint = "/grpc/orgs.Auth/GetAvailableApiScopes";
  /**
   * GetAvailableApiScopes returns the list of API scopes available for the caller.
   * It uses the caller's session to determine its role, and then the set of API scopes
   * available to that role.
   * FullStorians can test other roles by setting the 'fs-test-role' gRPC header with
   * the role name (i.e. 'USER', 'ADMIN', 'VIEW_ONLY', etc).
   */
  export function GetAvailableApiScopes(sender: (req: GetAvailableApiScopesRequest, endpoint: string) => Promise<GetAvailableApiScopesResponse>, req: GetAvailableApiScopesRequest): { promise: () => Promise<GetAvailableApiScopesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAvailableApiScopesEndpoint),
      endpoint: GetAvailableApiScopesEndpoint
    };
  }

  export const AuthenticateEndpoint = "/grpc/orgs.Auth/Authenticate";
  export function Authenticate(sender: (req: AuthenticateRequest, endpoint: string) => Promise<AuthenticateResponse>, req: AuthenticateRequest): { promise: () => Promise<AuthenticateResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AuthenticateEndpoint),
      endpoint: AuthenticateEndpoint
    };
  }

  export const CreatePasswordResetLinkEndpoint = "/grpc/orgs.Auth/CreatePasswordResetLink";
  /**
   * Creates a new password reset link to send to a user's email. If a user is not found in the current realm, this will
   * check other realms to validate the user exists and createe a reset link to that realm
   */
  export function CreatePasswordResetLink(sender: (req: PasswordResetLinkRequest, endpoint: string) => Promise<PasswordResetLinkResponse>, req: PasswordResetLinkRequest): { promise: () => Promise<PasswordResetLinkResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreatePasswordResetLinkEndpoint),
      endpoint: CreatePasswordResetLinkEndpoint
    };
  }

  export const AuthenticatePasswordResetTokenEndpoint = "/grpc/orgs.Auth/AuthenticatePasswordResetToken";
  /**
   * AuthenticatePasswordResetToken accepts a password reset token that deletes the current password and
   * returns a no-org signed session that can be used to authenticate a subsequent call to SetPassword.
   */
  export function AuthenticatePasswordResetToken(sender: (req: AuthenticateTokenRequest, endpoint: string) => Promise<PasswordResetResponse>, req: AuthenticateTokenRequest): { promise: () => Promise<PasswordResetResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AuthenticatePasswordResetTokenEndpoint),
      endpoint: AuthenticatePasswordResetTokenEndpoint
    };
  }

  export const AuthenticateInviteTokenEndpoint = "/grpc/orgs.Auth/AuthenticateInviteToken";
  /**
   * AuthenticateInviteToken exchanges an invite token for a new seat and person (if necessary) and returns a signed
   * session that can be used for authentication. If authentication must be done externally (e.g. Auth0), then the
   * signed session will be empty.
   */
  export function AuthenticateInviteToken(sender: (req: AuthenticateTokenRequest, endpoint: string) => Promise<AuthInviteResponse>, req: AuthenticateTokenRequest): { promise: () => Promise<AuthInviteResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AuthenticateInviteTokenEndpoint),
      endpoint: AuthenticateInviteTokenEndpoint
    };
  }

  export const AcceptInviteEndpoint = "/grpc/orgs.Auth/AcceptInvite";
  /**
   * AcceptInvite converts an invite into a new seat and person. We are basically accepting the user's outstanding
   * invite on their behalf. This is useful for when we want to provision a seat for a user on-the-fly
   * (e.g. SSO JIT provisioning).
   */
  export function AcceptInvite(sender: (req: AcceptInviteRequest, endpoint: string) => Promise<AcceptInviteResponse>, req: AcceptInviteRequest): { promise: () => Promise<AcceptInviteResponse>, endpoint: string } {
    return {
      promise: () => sender(req, AcceptInviteEndpoint),
      endpoint: AcceptInviteEndpoint
    };
  }

  export const GetAuthMethodEndpoint = "/grpc/orgs.Auth/GetAuthMethod";
  /** GetAuthMethod returns information regarding which auth method is used for the requested org */
  export function GetAuthMethod(sender: (req: GetAuthMethodRequest, endpoint: string) => Promise<AuthMethod>, req: GetAuthMethodRequest): { promise: () => Promise<AuthMethod>, endpoint: string } {
    return {
      promise: () => sender(req, GetAuthMethodEndpoint),
      endpoint: GetAuthMethodEndpoint
    };
  }

  export const GetPersonEndpoint = "/grpc/orgs.Auth/GetPerson";
  export function GetPerson(sender: (req: GetPersonRequest, endpoint: string) => Promise<Person>, req: GetPersonRequest): { promise: () => Promise<Person>, endpoint: string } {
    return {
      promise: () => sender(req, GetPersonEndpoint),
      endpoint: GetPersonEndpoint
    };
  }

  export const SetPasswordEndpoint = "/grpc/orgs.Auth/SetPassword";
  /** SetPassword sets the given password on the user. The given InviteTokenId and Token will be verified and invalidated. */
  export function SetPassword(sender: (req: SetPasswordRequest, endpoint: string) => Promise<SetPasswordResponse>, req: SetPasswordRequest): { promise: () => Promise<SetPasswordResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetPasswordEndpoint),
      endpoint: SetPasswordEndpoint
    };
  }

  export const UpdatePersonEndpoint = "/grpc/orgs.Auth/UpdatePerson";
  export function UpdatePerson(sender: (req: UpdatePersonRequest, endpoint: string) => Promise<Person>, req: UpdatePersonRequest): { promise: () => Promise<Person>, endpoint: string } {
    return {
      promise: () => sender(req, UpdatePersonEndpoint),
      endpoint: UpdatePersonEndpoint
    };
  }

  export const UpdatePersonLevel0Endpoint = "/grpc/orgs.Auth/UpdatePersonLevel0";
  /** Update level0 status for a Person */
  export function UpdatePersonLevel0(sender: (req: UpdatePersonLevel0Request, endpoint: string) => Promise<UpdatePersonLevel0Response>, req: UpdatePersonLevel0Request): { promise: () => Promise<UpdatePersonLevel0Response>, endpoint: string } {
    return {
      promise: () => sender(req, UpdatePersonLevel0Endpoint),
      endpoint: UpdatePersonLevel0Endpoint
    };
  }

  export const InvalidateSessionsEndpoint = "/grpc/orgs.Auth/InvalidateSessions";
  export function InvalidateSessions(sender: (req: InvalidateSessionsRequest, endpoint: string) => Promise<{}>, req: InvalidateSessionsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, InvalidateSessionsEndpoint),
      endpoint: InvalidateSessionsEndpoint
    };
  }

  export const GetSsoInfoEndpoint = "/grpc/orgs.Auth/GetSsoInfo";
  export function GetSsoInfo(sender: (req: {}, endpoint: string) => Promise<SsoInfo>, req: {}): { promise: () => Promise<SsoInfo>, endpoint: string } {
    return {
      promise: () => sender(req, GetSsoInfoEndpoint),
      endpoint: GetSsoInfoEndpoint
    };
  }

  export const PutSsoInfoEndpoint = "/grpc/orgs.Auth/PutSsoInfo";
  export function PutSsoInfo(sender: (req: PutSsoInfoRequest, endpoint: string) => Promise<{}>, req: PutSsoInfoRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, PutSsoInfoEndpoint),
      endpoint: PutSsoInfoEndpoint
    };
  }

  export const GetVerifiedSsoConnectionsEndpoint = "/grpc/orgs.Auth/GetVerifiedSsoConnections";
  export function GetVerifiedSsoConnections(sender: (req: GetVerifiedSsoConnectionsRequest, endpoint: string) => Promise<GetVerifiedSsoConnectionsResponse>, req: GetVerifiedSsoConnectionsRequest): { promise: () => Promise<GetVerifiedSsoConnectionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetVerifiedSsoConnectionsEndpoint),
      endpoint: GetVerifiedSsoConnectionsEndpoint
    };
  }

  export const AddVerifiedSsoConnectionEndpoint = "/grpc/orgs.Auth/AddVerifiedSsoConnection";
  export function AddVerifiedSsoConnection(sender: (req: AddVerifiedSsoConnectionRequest, endpoint: string) => Promise<{}>, req: AddVerifiedSsoConnectionRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, AddVerifiedSsoConnectionEndpoint),
      endpoint: AddVerifiedSsoConnectionEndpoint
    };
  }

  export const DeleteVerifiedSsoConnectionEndpoint = "/grpc/orgs.Auth/DeleteVerifiedSsoConnection";
  export function DeleteVerifiedSsoConnection(sender: (req: DeleteVerifiedSsoConnectionRequest, endpoint: string) => Promise<{}>, req: DeleteVerifiedSsoConnectionRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteVerifiedSsoConnectionEndpoint),
      endpoint: DeleteVerifiedSsoConnectionEndpoint
    };
  }

  export const IsSsoConnectionVerifiedEndpoint = "/grpc/orgs.Auth/IsSsoConnectionVerified";
  export function IsSsoConnectionVerified(sender: (req: IsSsoConnectionVerifiedRequest, endpoint: string) => Promise<boolean>, req: IsSsoConnectionVerifiedRequest): { promise: () => Promise<boolean>, endpoint: string } {
    return {
      promise: () => sender(req, IsSsoConnectionVerifiedEndpoint),
      endpoint: IsSsoConnectionVerifiedEndpoint
    };
  }

  export const GetEmbedOrgAccessTokenEndpoint = "/grpc/orgs.Auth/GetEmbedOrgAccessToken";
  /**
   * GetEmbedOrgAccessToken mints an AccessToken for a seat in an Embed-Only-Org
   * will fail if requested org is not Embed Only or does not belongs to the EmbedPartner in the context
   */
  export function GetEmbedOrgAccessToken(sender: (req: GetEmbedOrgAccessTokenRequest, endpoint: string) => Promise<GetEmbedOrgAccessTokenResponse>, req: GetEmbedOrgAccessTokenRequest): { promise: () => Promise<GetEmbedOrgAccessTokenResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetEmbedOrgAccessTokenEndpoint),
      endpoint: GetEmbedOrgAccessTokenEndpoint
    };
  }

  export const GetAccessTokenEndpoint = "/grpc/orgs.Auth/GetAccessToken";
  /**
   * GetAccessToken mints an access token for the current user in the context (session)
   * NB: the returned access token always removes PermMintOwnSession flag,
   * so that the returned tokens can not be used to mint new tokens
   */
  export function GetAccessToken(sender: (req: GetAccessTokenRequest, endpoint: string) => Promise<GetAccessTokenResponse>, req: GetAccessTokenRequest): { promise: () => Promise<GetAccessTokenResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAccessTokenEndpoint),
      endpoint: GetAccessTokenEndpoint
    };
  }

  export const SaveCrossRealmAuthInfoEndpoint = "/grpc/orgs.Auth/SaveCrossRealmAuthInfo";
  /**
   * SaveCrossRealmAuthInfo will take the given CrossRealmAuthInfo and write it as a short-lived entry to memcached.
   * It will return an opaque token that can be used to access the session _once_.
   * If the org ID provided for the given session info resides in a different realm, the request will be forwarded to
   * the target realm.
   */
  export function SaveCrossRealmAuthInfo(sender: (req: SaveCrossRealmAuthInfoRequest, endpoint: string) => Promise<SaveCrossRealmAuthInfoResponse>, req: SaveCrossRealmAuthInfoRequest): { promise: () => Promise<SaveCrossRealmAuthInfoResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SaveCrossRealmAuthInfoEndpoint),
      endpoint: SaveCrossRealmAuthInfoEndpoint
    };
  }

  export const LoadCrossRealmAuthInfoEndpoint = "/grpc/orgs.Auth/LoadCrossRealmAuthInfo";
  /** LoadCrossRealmAuthInfo will exchange an input token with a CrossRealmAuthInfo. */
  export function LoadCrossRealmAuthInfo(sender: (req: LoadCrossRealmAuthInfoRequest, endpoint: string) => Promise<LoadCrossRealmAuthInfoResponse>, req: LoadCrossRealmAuthInfoRequest): { promise: () => Promise<LoadCrossRealmAuthInfoResponse>, endpoint: string } {
    return {
      promise: () => sender(req, LoadCrossRealmAuthInfoEndpoint),
      endpoint: LoadCrossRealmAuthInfoEndpoint
    };
  }
}

/**
 * Service AuthPublic defines the subset of the Auth service methods that we want to
 * expose for direct calls from external clients like browsers running the FullStory app.
 * Internal clients (e.g. other gRPC services running on GKE in the same GCP project)
 * should not use AuthPublic; they should use the Auth service in this same package.
 */
export namespace AuthPublic {

  export const GetApiKeysEndpoint = "/grpc/orgs.AuthPublic/GetApiKeys";
  /** GetApiKeys fetches all the API keys to which a user has access. */
  export function GetApiKeys(sender: (req: GetApiKeysRequest, endpoint: string) => Promise<GetApiKeysResponse>, req: GetApiKeysRequest): { promise: () => Promise<GetApiKeysResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetApiKeysEndpoint),
      endpoint: GetApiKeysEndpoint
    };
  }

  export const DeleteApiKeyEndpoint = "/grpc/orgs.AuthPublic/DeleteApiKey";
  /** DeleteApiKey tombstones and removes a single key. */
  export function DeleteApiKey(sender: (req: DeleteApiKeyRequest, endpoint: string) => Promise<{}>, req: DeleteApiKeyRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteApiKeyEndpoint),
      endpoint: DeleteApiKeyEndpoint
    };
  }

  export const GenerateUserApiKeyEndpoint = "/grpc/orgs.AuthPublic/GenerateUserApiKey";
  /** GenerateUserApiKey creates and returns a new per-user API key and its identifying suffix */
  export function GenerateUserApiKey(sender: (req: GenerateUserApiKeyRequest, endpoint: string) => Promise<GenerateUserApiKeyResponse>, req: GenerateUserApiKeyRequest): { promise: () => Promise<GenerateUserApiKeyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GenerateUserApiKeyEndpoint),
      endpoint: GenerateUserApiKeyEndpoint
    };
  }

  export const UpdateUserApiKeyEndpoint = "/grpc/orgs.AuthPublic/UpdateUserApiKey";
  /**
   * UpdateUserApiKey updates the name and/or the role of of a given user api key. The request must contain either a
   * name update and/or role update, the api key metadata (seatId, suffix), and a valid org id. The new_role field
   * being set to orgs.Role_UNKNOWN and the new_name field being set to an empty string will be interpreted as a
   * no update. On a successful update, an empty protobuf message will be returned.
   */
  export function UpdateUserApiKey(sender: (req: UpdateUserApiKeyRequest, endpoint: string) => Promise<{}>, req: UpdateUserApiKeyRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateUserApiKeyEndpoint),
      endpoint: UpdateUserApiKeyEndpoint
    };
  }

  export const GetAvailableApiScopesEndpoint = "/grpc/orgs.AuthPublic/GetAvailableApiScopes";
  /**
   * GetAvailableApiScopes returns the list of API scopes available for the caller.
   * It uses the caller's session to determine its role, and then the set of API scopes
   * available to that role.
   */
  export function GetAvailableApiScopes(sender: (req: GetAvailableApiScopesRequest, endpoint: string) => Promise<GetAvailableApiScopesResponse>, req: GetAvailableApiScopesRequest): { promise: () => Promise<GetAvailableApiScopesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAvailableApiScopesEndpoint),
      endpoint: GetAvailableApiScopesEndpoint
    };
  }

  export const UpdateAppearanceModeEndpoint = "/grpc/orgs.AuthPublic/UpdateAppearanceMode";
  export function UpdateAppearanceMode(sender: (req: UpdateAppearanceModeRequest, endpoint: string) => Promise<{}>, req: UpdateAppearanceModeRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateAppearanceModeEndpoint),
      endpoint: UpdateAppearanceModeEndpoint
    };
  }
}

export interface GetApiMetadataRequest {
  entityId: string;
  /** The shared secret used to authenticate API client */
  secret: protobuf.bytes;
  /** The seat that is being authenticated. Blank if the API key used is a legacy org key. */
  seat: string;
  /** The suffix of the key that is being authenticated. Blank if the API key used is a legacy org key. */
  suffix: string;
}

export interface GetApiMetadataResponse {
  entityId: string;
  /** The authenticated seat. This is blank if a legacy org API key was used. */
  seat: string;
  /**
   * Maximum number of API calls allowed during the org's billing cycle.
   * 
   * @deprecated
   */
  maxCalls: number;
  /**
   * Total of calls made during the current billing cycle.
   * 
   * @deprecated
   */
  currentCalls: number;
  /**
   * Maximum rate of calls per second; bucket refresh rate.
   * 
   * @deprecated
   */
  ratePerSec: number;
  /**
   * Maximum number of requests allowed to exceed rate; bucket capacity.
   * 
   * @deprecated
   */
  maxBurst: number;
  /** True if authentication of the org/key combination was successful. */
  authnSuccessful: boolean;
  /** Feature/pack flags. These come from the org/umbrella and its plan configuration. */
  entityFlags: flags.FlagsProto | null;
  /**
   * Permission flags for the API token. The union of org_flags and perm_flags will be
   * used to authorize API requests.
   * 
   * These flags are the intersection of the seat's permissions and the key's permissions.
   * So an admin seat could define an admin key, which has wide permissions. And an agent
   * could define a read-only key, which has nothing but read-only permissions.
   * 
   * If a legacy org key is used, this will include all "owner" permissions.
   */
  permFlags: flags.FlagsProto | null;
  /** True if this seat is currently disabled */
  seatDisabled: boolean;
}

export interface GenerateUserApiKeyRequest {
  /**
   * Deprecated - use org_properties instead
   * 
   * @deprecated
   */
  orgId: string;
  /**
   * DO NOT USE. Use the authenticated identity in the signed session instead.
   * TODO(jh): update client to stop sending this request and then delete it
   * 
   * @deprecated
   */
  seatId: string;
  name: string;
  /**
   * Deprecated - use org_properties instead
   * 
   * @deprecated
   */
  role: Role;
  orgProperties?: OrgKeyProperties | null;
  embedPartnerProperties?: EmbedPartnerKeyProperties | null;
  scopedProperties?: ScopedKeyProperties | null;
}

export namespace GenerateUserApiKeyRequest {
  export enum properties {
    orgProperties = 5,
    embedPartnerProperties = 6,
    scopedProperties = 7
  }

  export function properties_oneof(m: GenerateUserApiKeyRequest): { opt: properties.embedPartnerProperties, val: EmbedPartnerKeyProperties } | { opt: properties.orgProperties, val: OrgKeyProperties } | { opt: properties.scopedProperties, val: ScopedKeyProperties } | null {
    if (m.orgProperties != null) { return { opt: properties.orgProperties, val: m.orgProperties } }
    if (m.embedPartnerProperties != null) { return { opt: properties.embedPartnerProperties, val: m.embedPartnerProperties } }
    if (m.scopedProperties != null) { return { opt: properties.scopedProperties, val: m.scopedProperties } }
    return null;
  }
}

export interface OrgKeyProperties {
  orgId: string;
  role: Role;
}

export interface EmbedPartnerKeyProperties {
  embedPartnerId: string;
  role: EmbedRole;
}

export interface ScopedKeyProperties {
  orgId: string;
  flags: flags.Flag[];
}

export interface GenerateUserApiKeyResponse {
  apiKey: string;
  suffix: string;
}

export interface UpdateUserApiKeyRequest {
  orgId: string;
  suffix: string;
  newName: string;
  newRole: Role;
  newFlags: flags.Flag[];
}

export interface GetApiKeysRequest {
  /** TODO(jess): add bool current_user_only to fetch keys only for the current user */
  orgId: string;
}

export interface ApiKeyMetadata {
  seatId: string;
  suffix: string;
  name: string;
  role: Role;
  generated: protobuf.timestamp | null;
  /** Permissions contained in the key, for scoped API keys only. */
  flags: flags.Flag[];
}

export interface GetApiKeysResponse {
  keys: ApiKeyMetadata[];
  numFailedKeys: number;
}

export interface DeleteApiKeyRequest {
  orgId: string;
  /** Omit if deleting a legacy key; required if suffix is specified */
  seatId: string;
  /** Omit if deleting a legacy key; required if seat_id is specified */
  suffix: string;
}

export interface DeleteApiKeysForSeatRequest {
  orgId: string;
  seatId: string;
}

export interface GetAvailableApiScopesRequest {
  orgId: string;
}

export interface GetAvailableApiScopesResponse {
  scopes: ApiScope[];
}

export interface AuthenticateRequest {
  userName: string;
  password: string;
  fetchCrossRealm: boolean;
}

export interface AuthenticateResponse {
  signedSession: string;
  email: string;
}

export interface AuthenticateError {
  reason: AuthenticateError.Reason;
  passwordResetToken: AuthToken | null;
}

export namespace AuthenticateError {
  export enum Reason {
    UNKNOWN = 0,
    PASSWORD_NOT_SET = 1,
    LOGIN_LOCKED = 2,
    INVALID_USER_NAME_OR_PASSWORD = 3,
    /** No orgs attached to the person indicates disabled status */
    LOGIN_DISABLED = 4
  }
}

export interface AuthToken {
  id: protobuf.int64;
  orgId: string;
  /** UmbrellaId is optional */
  umbrellaId: string;
  acctId: string;
  type: number;
}

export interface AuthenticateTokenRequest {
  email: string;
  tokenId: string;
  tokenHash: string;
  orgId: string;
  umbrellaId: string;
  /** Used for Verifying devices */
  verificationCode: string;
}

export interface PasswordResetLinkRequest {
  email: string;
  fetchCrossRealm: boolean;
}

export interface PasswordResetLinkResponse {
  resetLink: string;
}

export interface PasswordResetResponse {
  person: Person | null;
  signedSession: string;
}

export interface AuthInviteResponse {
  person: Person | null;
  org: Org | null;
  /** The signed session can be used to make subsequent authenticated calls. May be empty if external auth is required */
  signedSession: string;
  /** True if the invited person requires more setup (i.e. completing their profile) after accepting their invite */
  requiresSignup: boolean;
}

export interface AuthenticateTokenError {
  reason: AuthenticateTokenError.Reason;
}

export namespace AuthenticateTokenError {
  export enum Reason {
    UNKNOWN = 0,
    INVALID_TOKEN = 1,
    TOKEN_EXPIRED = 2,
    LOGIN_DISABLED = 3,
    TOKEN_USED = 4
  }
}

export interface GetAuthMethodRequest {
  orgId: string;
}

export interface AuthMethod {
  /** If true, users without a seat are allowed to view sessions */
  guestsEnabled: boolean;
  /** This message is present if the org has no preference for authentication */
  fullStory?: AuthMethod.FullStoryMethod | null;
  /** This message is present if the org has Auth0 SSO authentication set up */
  auth0?: AuthMethod.Auth0Method | null;
  /** This message is present if Google authentication is set up for the org */
  google?: AuthMethod.GoogleMethod | null;
}

export namespace AuthMethod {
  export interface Auth0Method {
    /** Whether or not this method is enforced */
    enforced: boolean;
    /** This is the human friendly reference to an org's Auth0 information */
    teamName: string;
  }

  export interface GoogleMethod {
    /** Whether or not this method is enforced */
    enforced: boolean;
  }

  /** This is the default method and requires username/password */
  export interface FullStoryMethod {
  }

  export enum method {
    /** This message is present if the org has no preference for authentication */
    fullStory = 2,
    /** This message is present if the org has Auth0 SSO authentication set up */
    auth0 = 3,
    /** This message is present if Google authentication is set up for the org */
    google = 4
  }

  export function method_oneof(m: AuthMethod): { opt: method.auth0, val: AuthMethod.Auth0Method } | { opt: method.fullStory, val: AuthMethod.FullStoryMethod } | { opt: method.google, val: AuthMethod.GoogleMethod } | null {
    if (m.fullStory != null) { return { opt: method.fullStory, val: m.fullStory } }
    if (m.auth0 != null) { return { opt: method.auth0, val: m.auth0 } }
    if (m.google != null) { return { opt: method.google, val: m.google } }
    return null;
  }
}

export interface GetPersonRequest {
  /** Will search for lower-cased email (unless fallback is true) */
  email: string;
  /** If true, will first check for lower-cased email, then if not found will check for as-is email */
  fallback: boolean;
  /**
   * If true, the orgs that the person can currently log into are returned
   * TODO(jh): should fetch_orgs=true fetch provisional orgs, too? or separate flag?
   */
  fetchOrgs: boolean;
  /** If true, it will also fetch person data from other realms */
  fetchRealms: boolean;
}

export interface UpdatePersonRequest {
  email: string;
  profileUpdate: UpdatePersonRequest.ProfileUpdate | null;
  searchTipsHidden: boolean | null;
}

export namespace UpdatePersonRequest {
  export interface ProfileUpdate {
    /** If any of these fields are empty, the corresponding value will not be updated */
    firstName: string;
    lastName: string;
    personas: string[];
    reason: string;
  }
}

export interface UpdatePersonLevel0Request {
  email: string;
  sawShare: boolean | null;
  sawSearch: boolean | null;
  sawRageAndDeadClicks: boolean | null;
  sawInspectMode: boolean | null;
  sawSearchies: boolean | null;
  gaveSearchV2Feedback: boolean | null;
  sawActivityMaps: boolean | null;
  sawFs3Warning2: boolean | null;
  sawFreemiumUpdate: boolean | null;
  /**
   * Flags of pro dialogs to add to "seen" list.
   * Flag state is discarded.
   */
  sawProDialogInTrial: number[];
  /**
   * Add/update OnboardingCompletion for the specified org,
   * and update the version for all other orgs for this Person.
   */
  onboardingCompletion: OnboardingCompletion | null;
}

export interface UpdatePersonLevel0Response {
  /** The updated Level0 */
  level0: PersonLevel0 | null;
}

export interface SetPasswordRequest {
  email: string;
  password: string;
  /**
   * TODO(sanjay): remove invite_ prefix for clarity. This is used for the forgot password flow as well.
   * Authentication token ID. Will be invalidated once verified.
   */
  inviteTokenId: string;
  /** Authentication token for verification. */
  token: string;
  /** OrgId for the invite token. */
  inviteOrgId: string;
  ipAddress: string;
}

export interface SetPasswordResponse {
  signedSession: string;
}

export interface SetPasswordError {
  reason: SetPasswordError.Reason;
}

export namespace SetPasswordError {
  export enum Reason {
    UNKNOWN = 0,
    INVALID_EMAIL = 1,
    INVALID_PASSWORD = 2,
    INVITE_NOT_FOUND = 3,
    NEEDS_EMAIL_VALIDATION = 4,
    PERSON_NOT_FOUND = 5
  }
}

export interface InvalidateSessionsRequest {
  email: string;
  /** If this is true, the password will be cleared and the user will have to use a token to login */
  forceEmailRevalidation: boolean;
  /** If true, will call all other sibling realms to invalidate all sessions in those realms */
  invalidateInOtherRealms: boolean;
}

export interface SsoInfo {
  role: string;
  created: protobuf.timestamp | null;
  firstName: string;
  lastName: string;
}

export interface PutSsoInfoRequest {
  ssoInfo: SsoInfo | null;
}

export interface CreateTeamDomainErrorDetail {
  /**
   * Multi failure details
   * Maps "{domain}/{team}" to an error message
   */
  failures: { [key: string]: string };
}

export interface GetEmbedOrgAccessTokenRequest {
  /** The embed partner that owns the org. */
  embedPartnerId: string;
  /** The org for which an access token is created. */
  orgId: string;
  /** The seat (in the org) for which an access token is created. */
  seatEmail: string;
  /**
   * The permissions to associated with the returned access token. The token
   * permissions will be an intersection of the seat's actual permissions and
   * the permissions associated with this role.
   * 
   * Note: we might normally need to also restrict the permissions to be no
   * more powerful than the permissions of the API key or access token used to
   * generate a token, to prevent privilege escalation. But for this endpoint,
   * the API key or token required to call this method must be scoped to an
   * embed partner, but the returned access token is scoped to an org.
   */
  restrictTo: Role;
}

export interface GetEmbedOrgAccessTokenResponse {
  accessToken: string;
}

export interface GetAccessTokenRequest {
  orgId: string;
  /**
   * Require callers to provide us a list of flags they want.
   * The permissions flags to associated with the returned access token. The token
   * permissions will be an intersection of the current signed session and
   * the permissions provided here.
   */
  requestedFlags: flags.Flag[];
}

export interface GetAccessTokenResponse {
  accessToken: string;
}

export interface SaveCrossRealmAuthInfoRequest {
  authInfo: CrossRealmAuthInfo | null;
}

export interface SaveCrossRealmAuthInfoResponse {
  /** Token to load the saved information. */
  token: string;
}

export interface CrossRealmAuthInfo {
  userInfo: UserInfo | null;
  org?: CrossRealmAuthInfo.OrgDestination | null;
  switchOrg?: CrossRealmAuthInfo.SwitchOrgDestination | null;
  authMethod: string;
  authTeamName: string;
  authProviderId: protobuf.int64;
}

export namespace CrossRealmAuthInfo {
  export enum destination_type {
    org = 2,
    switchOrg = 7
  }

  export function destination_type_oneof(m: CrossRealmAuthInfo): { opt: destination_type.org, val: CrossRealmAuthInfo.OrgDestination } | { opt: destination_type.switchOrg, val: CrossRealmAuthInfo.SwitchOrgDestination } | null {
    if (m.org != null) { return { opt: destination_type.org, val: m.org } }
    if (m.switchOrg != null) { return { opt: destination_type.switchOrg, val: m.switchOrg } }
    return null;
  }

  export interface OrgDestination {
    orgId: string;
    isShareLinkPath: boolean;
  }

  export interface ChooseOrgDestination {
    targetRealm: string;
  }

  export interface SwitchOrgDestination {
    sessionInfo: auth.SessionInfo | null;
    targetOrgId: string;
  }
}

export interface LoadCrossRealmAuthInfoRequest {
  /** Token to load the saved session information. */
  token: string;
}

export interface LoadCrossRealmAuthInfoResponse {
  authInfo: CrossRealmAuthInfo | null;
}

export interface AcceptInviteRequest {
  orgId: string;
  email: string;
}

export interface AcceptInviteResponse {
}

export interface AcceptInviteError {
  reason: AcceptInviteError.Reason;
}

export namespace AcceptInviteError {
  export enum Reason {
    UNKNOWN = 0,
    NO_INVITE_FOUND = 1
  }
}

export interface Destination {
  destination: string;
  org?: Destination.OrgDestination | null;
  crossRealm?: Destination.CrossRealmDestination | null;
  chooseOrg?: Destination.ChooseOrgDestination | null;
  idp?: Destination.IdpDestination | null;
  switchOrg?: Destination.SwitchOrgDestination | null;
}

export namespace Destination {
  export enum destination_type {
    org = 2,
    crossRealm = 3,
    chooseOrg = 4,
    idp = 5,
    switchOrg = 6
  }

  export function destination_type_oneof(m: Destination): { opt: destination_type.chooseOrg, val: Destination.ChooseOrgDestination } | { opt: destination_type.crossRealm, val: Destination.CrossRealmDestination } | { opt: destination_type.idp, val: Destination.IdpDestination } | { opt: destination_type.org, val: Destination.OrgDestination } | { opt: destination_type.switchOrg, val: Destination.SwitchOrgDestination } | null {
    if (m.org != null) { return { opt: destination_type.org, val: m.org } }
    if (m.crossRealm != null) { return { opt: destination_type.crossRealm, val: m.crossRealm } }
    if (m.chooseOrg != null) { return { opt: destination_type.chooseOrg, val: m.chooseOrg } }
    if (m.idp != null) { return { opt: destination_type.idp, val: m.idp } }
    if (m.switchOrg != null) { return { opt: destination_type.switchOrg, val: m.switchOrg } }
    return null;
  }

  export interface OrgDestination {
    orgId: string;
    isShareLinkPath: boolean;
  }

  export interface CrossRealmDestination {
  }

  export interface ChooseOrgDestination {
  }

  export interface IdpDestination {
  }

  export interface SwitchOrgDestination {
    sessionInfo: auth.SessionInfo | null;
    csrfToken: protobuf.bytes;
    targetOrgId: string;
  }
}

export interface UserInfo {
  email: string;
  role: string;
  firstName: string;
  lastName: string;
}

export interface UpdateAppearanceModeRequest {
  appearanceMode: AppearanceMode;
}

export interface AddVerifiedSsoConnectionRequest {
  email: string;
  connectionId: string;
}

export interface VerifiedSsoConnection {
  connectionId: string;
  validationDate: protobuf.timestamp | null;
}

export interface GetVerifiedSsoConnectionsRequest {
  email: string;
}

export interface GetVerifiedSsoConnectionsResponse {
  email: string;
  connections: VerifiedSsoConnection[];
}

export interface IsSsoConnectionVerifiedRequest {
  email: string;
  connectionId: string;
  fetchCrossRealm: boolean;
}

export interface DeleteVerifiedSsoConnectionRequest {
  email: string;
  connectionId: string;
}
